import React, { useState } from 'react';
import { Info, ExternalLink } from 'lucide-react';

const NewIntegrationPage = () => {
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  
  const integrationOptions = [
    { id: 'wordpress', name: 'WordPress', logo: '/wordpress-logo.png' },
    { id: 'webflow', name: 'Webflow', logo: '/webflow-logo.png' },
    { id: 'notion', name: 'Notion', logo: '/notion-logo.png' },
    { id: 'shopify', name: 'Shopify', logo: '/shopify-logo.png' },
    { id: 'wix', name: 'Wix', logo: '/wix-logo.png' },
    { id: 'wordpress-com', name: 'WordPress.com', logo: '/wordpress-com-logo.png' },
    { id: 'api-webhook', name: 'API Webhook', logo: '/api-webhook-logo.png' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-6 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Add New Integration</h1>
          <p className="text-gray-600">Connect your website with Hyperrank</p>
        </div>
        
        {/* Integration Options */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          {integrationOptions.map((integration) => (
            <div 
              key={integration.id}
              className="bg-gray-50 hover:bg-gray-100 transition rounded-lg p-6 cursor-pointer flex flex-col items-center justify-center"
              onClick={() => setSelectedIntegration(integration.id)}
            >
              <div className="w-12 h-12 mb-4 flex items-center justify-center">
                {/* Placeholder for logo */}
                <div className="bg-gray-200 w-10 h-10 rounded-full flex items-center justify-center">
                  {/* First letter of integration name as placeholder */}
                  <span className="text-lg font-bold">{integration.name.charAt(0)}</span>
                </div>
              </div>
              <h3 className="text-lg font-medium text-center">{integration.name}</h3>
            </div>
          ))}
        </div>
        
        {/* If you want to show different forms based on selected integration */}
        {selectedIntegration && (
          <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
            <h2 className="text-xl font-bold mb-4">Configure {integrationOptions.find(i => i.id === selectedIntegration)?.name} Integration</h2>
            <p className="text-gray-600">This is where the configuration form would appear</p>
            
            {/* Tutorial Link */}
            <div className="mt-4 bg-violet-50 p-4 rounded-lg">
              <a 
                href="#" 
                className="text-violet-700 font-medium inline-flex items-center"
              >
                Watch YouTube tutorial how to integrate your {integrationOptions.find(i => i.id === selectedIntegration)?.name} website with Hyperrank
                <ExternalLink size={16} className="ml-1" />
              </a>
            </div>
            
            {/* Form fields would go here */}
            <div className="mt-6">
              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-2">
                  Integration Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md p-2"
                  placeholder={`My ${integrationOptions.find(i => i.id === selectedIntegration)?.name} Website`}
                />
              </div>
              
              {/* Other fields would vary by integration type */}
              
              <div className="mt-8">
                <button className="w-full bg-violet-600 text-white py-3 rounded-md hover:bg-violet-700 transition font-medium">
                  Create
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewIntegrationPage;